import { ArrowRight, MessageCircle } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export function CTA() {
  const { t } = useLanguage();

  return (
    <section className="py-24 bg-[#7289d9] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>
      
      {/* Added disc image with 10% opacity */}
      <div className="absolute inset-0 flex items-center justify-center opacity-10">
        <img 
          src="/assets/disc.png" 
          alt="" 
          className="h-full max-h-[80vh] w-auto object-contain"
        />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          {t('cta_title')}
        </h2>
        <p className="text-xl text-blue-100 mb-10 leading-relaxed">
          {t('cta_text')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a 
            href="https://discord.gg/NuCx3ndCXn" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-4 bg-white text-blue-600 font-semibold rounded-lg hover:bg-gray-100 transform hover:scale-105 transition-all duration-200 shadow-xl hover:shadow-2xl"
          >
            {t('cta_button')}
            <ArrowRight className="ml-2 w-5 h-5" />
          </a>
          <div className="flex items-center text-white text-sm mt-4 sm:mt-0">
            <MessageCircle className="w-5 h-5 mr-2" />
            <span>Join us on Discord</span>
          </div>
        </div>
      </div>
    </section>
  );
}
